<template>
  <v-row class="flex-column mt-6 pr-8">
    <router-view :key="$route.fullPath" />
    <v-col v-if="$route.name === 'Domains'">
      <v-row no-gutters>
        <v-col md="2"><h2 class="title-1 m1-5 primary-text">Domains</h2></v-col>
        <v-col class="text-right">
          <v-btn icon @click="resetAll" class="mr-1">
            <v-icon>restart_alt</v-icon>
          </v-btn>
          <v-text-field
            v-model="search"
            class="custom-search"
            label="Search"
            solo
            append-icon="search"
            hide-details
            single-line
            @keyup="getDomainsList(), pageReset()"
          />
          <v-btn
            class="primary_btn small"
            depressed
            @click="$router.push({ name: 'addDomain' })"
            >Add Domain</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="$route.name === 'Domains'" class="custom-panel">
      <v-data-table
        id="domains"
        :headers="headers"
        :items="domains.data"
        :options.sync="options"
        :server-items-length="domains.total"
        :loading="loading"
        hide-default-footer
        :sort-desc.sync="sortDesc"
        :header-props="{ sortIcon: 'arrow_upward' }"
        @update:sort-desc="getDomainsList"
        class="elevation-1"
      >
        <template v-slot:item.name="{ item }">
          <b>
            {{ item.name }}
          </b>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col cols="6">
              <v-btn icon>
                <v-icon @click="$router.push(`/domains/edit-domain/${item.id}`)"
                  >edit</v-icon
                >
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <div class="primary-icon">
        <license-pagination
          :total="domains.total"
          :value="page"
          @input="pageEmit"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeActions } from '@/store/actions.constants';
import licensePagination from '@/components/LicensePagination/licensePagination.vue';
export default {
  components: { licensePagination },
  data: () => ({
    headers: [
      {
        text: 'Domain',
        align: 'start',
        value: 'name',
      },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    loading: false,
    page: 1,
    itemsPerPage: 10,
    sortDesc: [],
    options: {},
  }),
  computed: {
    ...mapGetters({
      domains: 'domains/getDomains',
    }),
  },
  async mounted() {
    if (this.options.page !== undefined) await this.getDomainsList();
  },
  methods: {
    ...mapActions({
      getDomains: 'domains/getDomain',
    }),
    pageReset() {
      if (this.search) {
        this.page = 1;
      }
    },
    pageEmit(data) {
      if (data > 0) this.page = data;
      this.getDomainsList();
    },
    resetAll() {
      this.search = '';
      this.page = 1;
      this.sortDesc = [];
      this.options.sortBy.length = 0;
      this.getDomainsList();
    },
    getDomainsList() {
      this.loading = true;
      const { sortBy } = this.options;
      this.getDomains({
        page: this.page,
        limit: 10,
        search: this.search || '',
        sort: sortBy[0],
        desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
